var map = {
	"./0.png": 8015,
	"./bazinga.png": 5741,
	"./bome.png": 6384,
	"./boz.gif": 5493,
	"./burn.gif": 3543,
	"./keeky.gif": 8189,
	"./sol.png": 5137
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8597;